import defaultSettings from "./defaultSettings";

export const ACTIONS = {
  UPDATE_LAYOUT: "UPDATE_LAYOUT",
  UPDATE_TEXT: "UPDATE_TEXT",
  RESET: "RESET",
};

export default function accessibilityReducer(state, action) {
  switch (action.type) {
    case ACTIONS.UPDATE_LAYOUT:
      return {
        ...state,
        layout: {
          ...state.layout,
          [action.key]: action.value,
        },
      };

    case ACTIONS.UPDATE_TEXT:
      return {
        ...state,
        text: {
          ...state.text,
          [action.key]: action.value,
        },
      };

    case ACTIONS.RESET:
      return defaultSettings;

    default:
      return state;
  }
}